import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './ButtonBar.css';
const ButtonBar = ({ children, className, align = 'left', size = 'normal', right, wrap = true }) => {
    const base = _jsx("div", { className: `buttonBar ${align}${wrap ? ' wrap' : ''}  ${className !== null && className !== void 0 ? className : ''} ${size}`, children: children });
    if (!right)
        return base;
    return _jsxs("div", { className: `bbContainer`, children: [base, _jsx("div", { className: `buttonBar right ${size}`, children: right })] });
};
export default ButtonBar;
